<template>
  <router-view style="height:100%;" :style="{background:this.$store.state.pageBackground}"></router-view>
</template>

<script>
export default {
  mounted: function() {
    //
    this.updateTableHeight();

    window.onresize = () => {
      this.updateTableHeight();
    };
  },
  methods: {
    updateTableHeight() {
      var documentHeight = document.body.clientHeight;
      this.$store.commit("UPDATE_TABLE_HEIGHT", documentHeight - 270);
    }
  }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// App.vue?d0862e2c